/**
 * Registers uploaded font attachments (.ttf/.otf/.woff) in the document so previews can use them.
 * Returns the CSS font-family name right away; `onLoad` runs once the font is ready to render.
 */
const families = {};

export function getAttachmentFontFamily(attachment, onLoad) {
    const url = attachment && attachment.attachment_file;
    if (!url || typeof url !== "string" || !window.FontFace || !document.fonts) {
        return "";
    }
    if (!families[url]) {
        const family = "individual-font-" + Object.keys(families).length;
        const font = new window.FontFace(family, `url("${url}")`);
        families[url] = {family, loaded: false, callbacks: []};
        font.load().then((loaded) => {
            document.fonts.add(loaded);
            families[url].loaded = true;
            families[url].callbacks.forEach((cb) => cb());
            families[url].callbacks = [];
        }, (error) => console.log("Font loading failed", url, error));
    }
    const entry = families[url];
    if (!entry.loaded && onLoad && entry.callbacks.indexOf(onLoad) === -1) {
        entry.callbacks.push(onLoad);
    }
    return entry.family;
}



// WEBPACK FOOTER //
// ./sources/utility/font-face.helper.js